/**
 * This is just an input field that keeps the cursor stable when value is changed.
 */

import { Input } from "antd";
import { useEffect, useState } from "react";

export default function FixedInput({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (val: string) => void;
}) {
  const [val, setVal] = useState(value);

  const updateVal = (val: string) => {
    setVal(val);
    onChange(val);
  };

  useEffect(() => {
    setVal(value);
  }, [value]);

  return (
    <Input
      value={val}
      onChange={(e) => updateVal(e.target.value)}
    />
  );
}
